<template>
  <header v-if="!bHideHeader" class="header h-40 flex items-center pl-24 text-22 font-700">
    <div class="flex hover:cursor-pointer" @click="back2opener">
      <img class="w-120 h-32 mr-8" src="@/assets/logo_red.png" />
    </div>

    <!-- 用户 -->
    <template v-if="userName">
      <div @mouseover="changeVisible(true)" @mouseleave="changeVisible(false)" class="right-item" :style="{height: '40px'}">
        <span
          class="items"
          >
          <IconUser :style="{fontSize: '24px'}"></IconUser>
          <div
            class="userDialog"
            v-show="bShowUser">
            <div class="userTitle">
              <IconUser :style="{fontSize: '24px'}"></IconUser>
              <span :title="userName">{{userName}}</span>
            </div>
            <div class="userExit" @click="loginOut">
              <div>{{$t('signOut.button')}}</div>
            </div>
          </div>
        </span>
      </div>
    </template>
  </header>
  <main style="height: calc(100% - 40px); width: 100%; overflow-x: hidden">
    <RouterView :hideHeader="hideHeader"/>
  </main>
</template>

<script setup>
import $t from '@/utils/lan';
import IconUser from '@/assets/icon-user.svg';
import { onMounted, ref, watch } from 'vue';
const userName = ref('test');
const bHideHeader = ref(false);
const bShowUser = ref(false);
import { useRouter } from 'vue-router';
const router = useRouter();

const back2opener = () => {
  router.push(`/ProjectManage`);
};
const hideHeader = () => {
  bHideHeader.value = true;
};
// watch(window.location.href, newVal => {
//   if (newVal.includes('platform')) {
//     hideHeader();
//   } else {
//     bHideHeader.value = false;
//   }
// });
onMounted(() => {
  setTimeout(() => {
    const userNameStr = sessionStorage.getItem('userName') || 'user';
    userName.value = userNameStr;
  }, 100);
  // const favicon = document.getElementById('favicon')
  // favicon.href = 'logo.svg'
});
const changeVisible = (visible) => {
  bShowUser.value = visible;
}
const loginOut = () => {
  sessionStorage.removeItem('Authorization');
  sessionStorage.removeItem('userName');
  window.location.href = 'https://www.hik-partner.com';
  // loginOut
};
</script>

<style lang="scss" scoped>
body {
  overflow: hidden;
  left: 0;
  top: 0;
}
.header{
  z-index: 9999;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  justify-content: space-between;
}
.right-item {
    cursor: default;
    display: flex;
    align-items: center;
    margin-right: 20px;
  .items {
    position: relative;
    cursor: pointer;
    display: inline-block;
    &:hover {
      border-color: rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.04);
    }

    .icon {
      margin-right: 0;
    }
  }
}
.userDialog {
  position: absolute;
  top: 32px;
  z-index: 15;
  right: -10px;
  min-width: 120px;
  max-width: 246px;
  padding: 4px 12px;
  background: rgb(255, 255, 255);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.9);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  .userTitle {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    &:hover {
      background: whitesmoke;
    }
    span {
      width: calc(100% - 28px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.7);
    }
  }
  .userExit {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    &:hover {
      background: whitesmoke;
    }
    div {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.7);
    }
  }
}
</style>
